import React from 'react';

import { Header } from '../components/header/header';
import { SvgCardType } from '../components/svg-card/svg-card-types';

interface Props {
    svgCardType: SvgCardType;
    title: string;
    subtitle: string;
    showSubtitle?: boolean;
}

export const SporsmalsflytHeader: React.FC<Props> = ({ svgCardType, title, subtitle, showSubtitle }) => {
    return <Header svgCardType={svgCardType} title={title} subtitle={subtitle} showSubtitle={showSubtitle} />;
};
